// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import "./channels"

// import jquery from "jquery"
// window.jQuery = jquery
// window.$ = jquery

// import "cocoon-js-vanilla"

import LocalTime from "local-time"
LocalTime.start()

// import "flatpickr"
// import "cleave.js"
// import "cleave.js/dist/addons/cleave-phone.us"
// import "choices.js"

import 'slim-select'
// import 'slim-select/styles'

// import "./src/custom"